import i18n from '@/plugins/i18n'
export default {
  browse: {
    table: {
      headers: [{
          text: i18n.t("model.prop.no"),
          value: 'index',
          sortable: false,
          filterable: false,
        },

        {
          text: i18n.t("model.name.event"),
          value: 'name',
        },
        {
          text: i18n.t("model.prop.status"),
          value: 'eventStatus',
          filterable: false,
        },
        {
          text: i18n.t("model.name.school"),
          value: 'School.name',
        },
        {

          value: 'delete',
          sortable: false,
          filterable: false,
        },
      ],
    },
  },

  add: {
    fields: [{
      type: 'model',
      key: 'eventId',
      name: 'Event',
      model: 'event',
    }, ],
    rules: {
      eventId: [v => !!v || 'Event is required'],
    },
  },
  edit: false,
  delete: true,
  read: false,
}